import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/configureStore";
import { GiContract, GiExpand } from "react-icons/gi";
import { ImVolumeHigh, ImVolumeMute2 } from "react-icons/im";
import { getSessionSetting } from "./selectors";
import { setSessionSetting } from "./sessionSlice";
import useSessionId from "./useSessionId";

const SubscriberControls = () => {
  const dispatch = useAppDispatch();
  const sessionId = useSessionId();
  const isFullScreen = useAppSelector(
    getSessionSetting(sessionId, "isFullScreen"),
  );
  const isMuted = useAppSelector(getSessionSetting(sessionId, "isMuted"));

  const toggleFullScreen = useCallback(() => {
    dispatch(setSessionSetting(sessionId, "isFullScreen", !isFullScreen));
  }, [dispatch, isFullScreen, sessionId]);

  const toggleMute = useCallback(() => {
    dispatch(setSessionSetting(sessionId, "isMuted", !isMuted));
  }, [dispatch, isMuted, sessionId]);

  return (
    <div>
      {isMuted ? (
        <ImVolumeMute2
          className="sub-toggle-mute"
          size="2em"
          onClick={toggleMute}
        />
      ) : (
        <ImVolumeHigh
          className="sub-toggle-mute"
          size="2em"
          onClick={toggleMute}
        />
      )}
      {isFullScreen ? (
        <GiContract
          className="sub-fullscreen-toggle"
          onClick={toggleFullScreen}
          size="2em"
        />
      ) : (
        <GiExpand
          className="sub-fullscreen-toggle"
          onClick={toggleFullScreen}
          size="2em"
        />
      )}
      <style jsx>{`
        :global(.sub-fullscreen-toggle) {
          color: rgba(255, 255, 255, 0.8);
          justify-self: flex-end;
        }
        :global(.sub-toggle-mute) {
          color: rgba(255, 255, 255, 0.8);
        }
        div {
          padding: 20px 40px;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          width: 100%;
          height: 100%;
          position: absolute;
        }
      `}</style>
    </div>
  );
};

export default SubscriberControls;
